import Backbone from 'backbone'
import _ from 'underscore'
import ModalView from './modal-view'

class ModalListViews extends Backbone.View {
    initialize () {
        // Elemento que se repete na página
        this.setElement('.modal-body')

        _.each(this.$el, (obj) => {
            new ModalView({
                el: obj
            })
        })
    }
}

export default ModalListViews
